<template>
  <!-- 活动详情页面 -->
  <div class="page-container">
    <!-- 选项卡按钮 -->
    <div style="margin-bottom: 20px; text-align: left">
      <el-button
        round
        size="small"
        :class="{ changtype: changetype == 1 }"
        @click="changePage()"
      >
        同期活动详情
      </el-button>
      <el-button
        round
        size="small"
        @click="changePage_hit()"
        :class="{ changtype: changetype == 2 }"
      >
        活动报名观众详情
      </el-button>
    </div>

    <!-- 同期活动详情 -->
    <div v-if="changetype == 1" class="page-card">
      <!-- 活动详情头部 -->
      <div class="page-card__header">
        <el-row>
          <el-col :span="4"> 同期活动详情</el-col>
          <el-col :span="20">
            <div style="text-align: right">
              <el-button type="primary" size="small" @click="updateInfo">修改</el-button>
              <el-button size="small" @click="deteleProduct">删除</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 活动信息展示 -->
      <div v-if="changInfoshow" class="page-card__body">
        <div style="width: 800px; margin: 0 auto">
          <div style="font-size: 16px; font-weight: bold; line-height: 40px">
            {{ info.title }}
          </div>
          <div style="font-size: 14px; line-height: 28px">
            主讲：{{ info.host }}
          </div>
          <div style="font-size: 14px; line-height: 28px">
            活动方式：{{ info.type }}
          </div>
          <div
            style="background-color: #f2f2f2; padding: 16px 0; margin: 10px 0"
          >
            <div style="font-size: 14px; line-height: 28px">
              时间： {{ start_time }} 至 {{ end_time }}
            </div>
            <div style="font-size: 14px; line-height: 28px">
              地址：{{ info.address }}
            </div>
          </div>
          <div v-html="info.info" class="ql-editor"></div>
          <div style="margin: 20px 0; text-align: right; font-size: 14px">
            <span style="margin-right: 10px">浏览量：{{ info.view }} </span>
            <span style="margin-right: 10px">点击数：{{ info.praise }}</span>
            <span style="margin-right: 10px">转发数：{{ info.share }}</span>
          </div>
        </div>
      </div>

      <!-- 活动信息编辑表单 -->
      <div v-else class="page-card__body">
        <div>
          <el-form ref="form" :model="form" :rules="rules" label-width="80px"  >
            <el-image v-if="form.logo !== ''"
                      :src="imgUrl+form.logo" style="width: 200px;height: 200px"></el-image>
            <el-form-item prop="img" label-width="0px">
              <el-upload
                class="avatar-uploader"
                :action="imagesrc"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :headers="headers"
                :before-upload="beforeAvatarUpload">
                <el-button size="small" type="primary" round>点击上传LOGO</el-button>
                <div slot="tip" class="el-upload__tip">最佳展示尺寸：1:1，建议500 x 500像素以上</div>
              </el-upload>
            </el-form-item>

            <el-form-item label="活动标题" prop="title">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="公司名" prop="company">
              <el-input v-model="form.company"></el-input>
            </el-form-item>
            <el-form-item label="活动描述" prop="desc">
              <el-input v-model="form.desc"></el-input>
            </el-form-item>
            <el-form-item label="主讲人" prop="host">
              <el-input v-model="form.host"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="position">
              <el-input v-model="form.position"></el-input>
            </el-form-item>
            <el-form-item label="活动方式" prop="type" style="text-align: left">
              <el-radio-group v-model="form.type">
                <el-radio label="线上">线上</el-radio>
                <el-radio label="线下">线下</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="活动方式">
              <el-col :span="5">
                <el-form-item label="" prop="start_time">
                  <el-date-picker
                    type="datetime"
                    placeholder="选择开课日期"
                    v-model="form.start_time"
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>
              </el-col>

              <el-col class="line" :span="2">-</el-col>

              <el-col :span="5">
                <el-form-item label="" prop="end_time">
                  <el-date-picker
                    type="datetime"
                    placeholder="选择结课日期"
                    v-model="form.end_time"
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item label="活动地址" prop="address">
              <el-input v-model="form.address"></el-input>
            </el-form-item>

            <el-form-item label="活动内容" prop="info">
              <tiny-editor
                v-model="form.info"
                :init="init"
                id="textarea"
              ></tiny-editor>
            </el-form-item>

            <el-form-item>
              <el-col :span="12" style="text-align: right; padding-right: 10px">
                <el-button type="primary" round size="small" @click="onBaseSubmit('form')"
                >修改活动
                </el-button>
              </el-col>
              <el-col :span="12" style="text-align: left; padding-left: 10px">
                <el-button round size="small" @click="back">取消修改</el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 活动报名观众列表 -->
    <div v-else-if="changetype == 2" class="page-card">
      <div class="page-card__body">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="wx_user_detail.name" label="姓名">
          </el-table-column>
          <el-table-column prop="wx_user_detail.company" label="所属公司">
          </el-table-column>

          <el-table-column prop="wx_user_detail.phone_number" label="联系电话">
          </el-table-column>
          <el-table-column prop="wx_user_detail.position" label="职位">
          </el-table-column>

          <el-table-column prop="create_time" label="报名日期"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="action-btn--danger"
                @click="delete_u(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页区域 -->
      <div style="margin: 20px 0; padding: 20px 0; text-align: center">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import editor from "@tinymce/tinymce-vue";
  import api from "../../utils/api";
  import {VueEditor} from "vue2-editor";

  export default {
    name: "activityDatail",
    data() {
      return {
        init: {
          // 编辑器配置信息
          selector: "#textarea",
          height: 550,
          language_url: "/static/tinymce/langs/zh-Hans.js",
          language: "zh-Hans",
          menubar: true,
          image_dimensions: false,
          images_upload_url:
            "https://cloudexhibition.chinafastenerinfo.com/api/admin/uploadfile/news/",
          images_upload_base_path:
            "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/",

          plugins: [
            "advlist autolink lists link image imagetools charmap print preview anchor textcolor imageupload",
            "searchreplace visualblocks code fullscreen ",
            "insertdatetime media table contextmenu paste code help wordcount",
          ],
          toolbar:
            "preview link code insertdatetime  charmap | media  image | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | help",
          automatic_uploads: true,
          images_upload_handler: function (blobInfo, succFun, failFun) {
            var xhr, formData;
            var file = blobInfo.blob();
            xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.open(
              "POST",
              "https://cloudexhibition.chinafastenerinfo.com/api/admin/uploadfile/news/"
            );

            xhr.setRequestHeader(
              "Authorization",
              "JWT " + localStorage.getItem("adminToken")
            );
            xhr.setRequestHeader("XMLHttpRequest", "HeaderValue");

            xhr.onload = function () {
              var json;
              if (xhr.status != 200) {
                failFun("HTTP Error: " + xhr.status);
                return;
              }
              json = JSON.parse(xhr.responseText);
              succFun(
                "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/" +
                json.filename
              );
            };
            formData = new FormData();
            formData.append("file", file, file.name);
            xhr.send(formData);
          },
        },
        start_time: "",
        end_time: "",
        customToolbar: [],
        form: {
          logo: '',
          title: "",
          type: "",
          company: '',
          position: '',
          address: "",
          desc: "",
          host: "",
          info: "",
          start_time: "",
          end_time: "",
        },
        rules: {
          title: [{required: true, message: "请输入活动名称", trigger: "blur"}],
          type: [{required: true, message: "请选择活动类型", trigger: "blur"}],
          address: [
            {required: true, message: "请输入活动地址", trigger: "blur"},
          ],
          company: [{
            required: true, message: "请输入公司名", trigger: "blur"
          }],
          position: [{
            required: true, message: "请输入职位", trigger: "blur"
          }],
          desc: [{required: true, message: "请输入描述", trigger: "blur"}],
          host: [{required: true, message: "请输入主讲人", trigger: "blur"}],
          info: [{required: true, message: "请输入活动内容", trigger: "blur"}],
          start_time: [
            {required: true, message: "请选择开始时间", trigger: "blur"},
          ],
          end_time: [
            {required: true, message: "请选择结束时间", trigger: "blur"},
          ],
        },
        id: "",
        info: [],
        tableData: [],
        changetype: 1,
        showModuleName: true,
        changInfoshow: true,
        newimgUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/",
        // 分页相关数据
        aSum: 0,
        currentPage: 1,
        pageCount: 1,
        pagesize: 10,
        headers: {"Authorization": "JWT " + localStorage.getItem('adminToken')},
        imagesrc: this.baseUrl + "/admin/uploadfile/activity/",
        imgUrl: 'https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/activity/',
      };
    },
    mounted() {
      // 初始化加载活动信息和报名用户列表
      this.id = this.$route.query.id;
      this.activityInfo();
      this.getUserList();
    },
    methods: {
      // 获取活动详情信息
      activityInfo() {
        let a_id = this.id;
        let url = this.baseUrl + "/admin/activitys/" + a_id + "/";
        api.fetchData(url).then((res) => {
          this.form = res;
          this.start_time = res.start_time;
          this.end_time = res.end_time;
          this.form.start_time = new Date(this.form.start_time);
          this.form.end_time = new Date(this.form.end_time);
          this.info = res;
        });
      },

      // 获取活动报名用户列表
      getUserList() {
        let url = this.baseUrl + "/admin/activity_registers/?activity=" + this.id;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      // 分页切换处理
      handleCurrentChange(val) {
        let url =
          this.baseUrl +
          "/admin/activity_registers/?activity=" +
          this.id +
          "&page=" +
          val;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        });
      },

      // 提交修改活动信息
      onBaseSubmit(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            let a_id = this.id;
            let url = this.baseUrl + "/admin/activitys/" + a_id + "/";

            this.form.start_time = this.TimeChange(this.form.start_time);
            this.form.end_time = this.TimeChange(this.form.end_time);
            api
              .patchData(url, {
                title: this.form.title,
                type: this.form.type,
                address: this.form.address,
                desc: this.form.desc,
                logo: this.form.logo,
                company: this.form.company,
                position: this.form.position,
                host: this.form.host,
                info: this.form.info,
                start_time: this.form.start_time,
                end_time: this.form.end_time,
              })
              .then((res) => {
                this.$message({
                  message: "修改活动成功",
                  type: "success",
                });
                this.updateInfo();
                this.activityInfo();
              });
          }
        });
      },

      // 日期格式化处理
      TimeChange(e) {
        var date = new Date(e);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var min = date.getMinutes();
        min = min < 10 ? "0" + min : min;
        var s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + m + "-" + d + "T" + h + ":" + min + ":" + s;
      },

      // 删除活动
      deteleProduct() {
        this.$confirm("将删除此条信息，是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let a_id = this.id;
          let url = this.baseUrl + "/admin/activitys/" + a_id + "/";
          api.deleteData(url).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.$router.push({name: "admin_activityList"});
          });
        });
      },

      // vue-html5-editor富文本函数
      updateData: function (data) {
        this.form.info = data;
      },

      // 富文本编辑器上传图片回调函数
      handleImageAdded(file, Editor, cursorLocation, resetUploader) {
        let url = this.baseUrl + "/admin/uploadfile/news/";
        const formData = new FormData();
        formData.append("file", file);
        api.postData(url, formData).then((res) => {
          Editor.insertEmbed(
            cursorLocation,
            "image",
            this.newimgUrl + res.filename
          );
          resetUploader();
        });
      },

      // 切换到活动详情视图
      changePage() {
        this.changetype = 1;
      },

      // 切换到报名观众列表视图
      changePage_hit() {
        this.changetype = 2;
      },

      // 切换信息展示/编辑状态
      updateInfo() {
        this.changInfoshow = this.changInfoshow === true ? false : true;
      },

      // 跳转到观众详情页
      handleClick(row) {
        this.$router.push({name: "admin_viewerDetail", query: {id: row.id}});
      },

      // 删除报名用户
      delete_u(row) {
        this.$confirm("将删除此条信息，是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let id = row.id;
          let url = this.baseUrl + "/admin/activity_registers/" + id + "/";
          api.deleteData(url).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getUserList();
          });
        });
      },

      // 返回活动列表页
      back() {
        this.$router.push({name: "admin_activityList"});
      },

      // 图片上传成功回调
      handleAvatarSuccess(res, file) {
        let imageUrl = URL.createObjectURL(file.raw);
        this.form.logo = res.filename;
      },

      // 图片上传前校验
      beforeAvatarUpload(file) {
      }
    },
    components: {
      VueEditor,
      "tiny-editor": editor,
    },
  };
</script>

<style scoped>
  .changtype {
    background-color: var(--color-primary);
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/activityDatail.vue